import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/baseStore'
import menu from './modules/menuStore'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        global,
        menu,
    },
    strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js